var View = require('views/base/view');

var ActivityLinkView = View.extend({
  noWrap: true,
  autoRender: true,
  initialize: function(options) {
    this.template = options.activityTemplate ? require(options.activityTemplate) : require('./templates/activity-link');
    View.prototype.initialize.apply(this, arguments);
  }
});

module.exports = ActivityLinkView;